<div class="sub-header">
	<div [class]="'container-fluid p-a-0 ' + view">
		<div class="row header-row searchbar-result-row">
			<div class="col-7 col-xl-8 searchbar-result-col">
				<span (click)="goBack()" class="phb-icon icon--arrow-dropleft col-back"></span>

				<p>
					<span class="d-none d-sm-inline">
						{{ 'search_term' | translate:systemLanguage }}: &quot;<strong
						class="search-term">{{ query }}</strong>&quot;
					</span>
					@if (!loading) {
						<span>- {{ 'search_hits' | translate:systemLanguage }}:
                            <strong>{{ hits }}</strong>
                        </span>
					}
				</p>
			</div>
		</div>
	</div>
</div>

<div class="page-content" #pageTop>
	<div [class]="'container-fluid p-a-0 ' + view">
		<!-- body -->
		<div class="search-result-wrapper">
			<ng-container>
				<div class="h-100">
					<div class="row h-100">
						<div class="col-3 h-100 overflow-auto">
							<div class="search-filter-outer">
								<div class="search-filter">
									<div class="search-filter__header">
										<h3>{{ 'search' | translate:systemLanguage }}</h3>
										<div class="search-filter__label">
											<h4>{{ 'search_filter' | translate:systemLanguage }}</h4>
											<div>
												<button (click)="reset()" class="mat-small-button" color="light" mat-flat-button>{{ 'search_reset' | translate:systemLanguage }}</button>
												<button (click)="search()" class="mat-small-button" mat-flat-button color="primary">{{ 'search_submit' | translate:systemLanguage }}</button>
											</div>
										</div>
									</div>


									<div class="search-filter__items">
										@for(tagGroup of tagGroups; track tagGroup.id) {
											<ng-template [ngTemplateOutlet]="searchFilterTagGroup" [ngTemplateOutletContext]="{ group:tagGroup }"></ng-template>
										}
									</div>
								</div>
							</div>
						</div>


						<div class="col-9 h-100 overflow-auto">
							@if(!loading) {
								<div class="search-filter-results-outer">
									<div class="row">
										<div class="col-9">


											<div class="search-filter-results">

												<div class="search-filter-results__header">

													<!--
                                                    <div class="search-filter-results__header__count">
                                                        <span>{{hits}} {{'search_hits' | translate:systemLanguage}}</span>
                                                    </div>
                                                    -->

													<div class="d-flex justify-content-between">
														<div class="search-filter-results__header__tags">
															@for(tag of allSelectedTags; track tag.id) {
																<span class="search-filter-results__header__tag" (click)="tagClick(tag)">{{ tag.caption | caption }}</span>
															}
														</div>
														<!--<span class="search-filter-results__header__detail-switch" (click)="expandDetails = !expandDetails" [innerHTML]="!expandDetails ? 'Mehr Details' : 'Weniger Details'"></span>-->
													</div>

												</div>

												<div class="search-filter-results__items">
													@if (!error) {
														@if (searchResult && searchResult.length > 0) {
															@for (result of searchResult; track result) {
																@defer (on viewport) {
																	<div class="search-filter-results__item d-flex">
																		<div class="search-filter-results__item-icon">
																			@if (!result.exists) {
																				<span size="small" class="phb-icon phb-icon--small icon--cloud-download col-back"></span>
																			}

																			<img [src]="result.mimeType | filetypeIcon" [alt]="result.mimeType"/>
																		</div>
																		<div class="search-filter-results__item-details">
																			<h3 class="m-t-0">
																				<a [routerLink]="result.exists ? ['/search-result',result.isoCode,result.id] : null">{{ result.caption }}</a>
																			</h3>
																			@if (expandDetails) {
																				<span>{{ result.name }}</span>
																			}

																			<!--
                                                                            @if(expandDetails) {
                                                                                <p>{{result.file.description}}</p>
                                                                            }
                                                                            -->
																			@if (result.tags || !expandDetails) {
																				<ul class="search-filter-results__item-details-tags">
																					@if (!expandDetails) {
																						<li>
																							<a (click)="langTagClick(result.hit.isoCode)">{{ (result.hit.isoCode | languageByIsoCode).title }}</a>
																						</li>
																					}

																					@if (result.section) {
																						<li>
																							<a (click)="sectionTagClick(result.section)">{{ ((result.section | node) | async) | caption }}</a>
																						</li>
																					}

																					@for(tag of result.tags; track tag.id) {
																						<li>
																							<a (click)="tagClick(tag)">{{ tag.caption | caption }}</a>
																						</li>
																					}

																				</ul>
																			}

																			<!--
                                                                            @if(expandDetails){
                                                                                <ul class="search-filter-results__item-details-languages">
                                                                                    <li>
                                                                                        <a [routerLink]="result.exists ? ['/search-result',result.hit.isoCode,result.id] : null" *ngFor="let language of result.file | nodeLanguages">{{(language | languageByIsoCode).title}}</a>
                                                                                    </li>
                                                                                </ul>
                                                                            }
                                                                            -->
																		</div>
																		<div class="search-filter-results__item-date">
																			<div>{{ result.modificationTime | date:"yyyy" }}</div>
																			@if (!isElectron) {
																				<div>{{ result.size | filesize }}</div>
																			}
																		</div>
																	</div>
																}
																@placeholder {
																	<div>xxx</div>
																}
															}

														} @else {
															<p>
																{{ 'search_no_results' | translate:systemLanguage }}
															</p>
														}
													} @else {
														<p>
															{{ 'search_error' | translate:systemLanguage }}
														</p>
													}
												</div>
											</div>
										</div>
									</div>
									@if (showMore) {
										<div class="row">
											<div class="col-12">
												<div class="text-content text-center">
													<button color="primary" mat-flat-button (click)="more()"
														[disabled]="asyncLoading">{{ 'btn_more' | translate:systemLanguage }}
													</button>
												</div>
											</div>
										</div>
									}
								</div>
							} @else {
								<div class="loading-screen"></div>
							}
						</div>
					</div>

				</div>
			</ng-container>
		</div>
		<!--/body-->
	</div>
</div>



<ng-template #searchFilterTagGroup let-group="group">
	<div class="search-filter__item search-filter__item--collapse" [class.search-filter__item--collapsed]="group.collapsed === undefined || group.collapsed">
		<h4 class="search-filter__item__label" (click)="setGroupCollapse(group)">{{ group.caption | caption:systemLanguage }}</h4>
		<ul class="search-filter__item__filters">
			@for(tag of group.tags; track tag.id) {
				<li>
					<label>
						<input type="checkbox" (change)="toggleTag(tag,group)" [checked]="tagChecked(tag,group)"/>
						{{ tag.caption | caption:systemLanguage }}
					</label>
				</li>
			}
		</ul>
	</div>
</ng-template>

